// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import styles from '@app/features/app/components/layout/pioneer/PioneerSidebar.module.css';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {DMListItem} from '@app/features/channel/components/direct_message/DMListItem';
import Channels from '@app/features/channel/state/Channels';
import {getSortedDmChannels} from '@app/features/messaging/utils/DmChannelUtils';
import {useLocation} from '@app/features/platform/components/router/RouterReact';
import Users from '@app/features/user/state/Users';
import {observer} from 'mobx-react-lite';

/** Direct messages continue the Chats list under the team's channels, as in the design. */
export const PioneerDirectMessages = observer(() => {
	const {pathname} = useLocation();
	const currentUserId = Users.currentUser?.id ?? null;
	const channels = RuntimeConfig.directMessagesDisabled ? [] : getSortedDmChannels(Channels.dmChannels, currentUserId);

	if (channels.length === 0) return null;
	return (
		<div className={styles.dmSection} data-flx="app.pioneer.pioneer-direct-messages.dm-section">
			{channels.map((channel) => (
				<DMListItem
					key={channel.id}
					channel={channel}
					isSelected={pathname === Routes.dmChannel(channel.id)}
					data-flx="app.pioneer.pioneer-direct-messages.dm-list-item"
				/>
			))}
		</div>
	);
});
